import React from "react";
import { Switch, Route, useParams } from "react-router-dom";

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import AuditShow from 'views/Audit/Show.js';
import ProofForm from 'views/Form/Proof/Auditor.js';
import EvaluationForm from 'views/Form/Evaluation/Auditor.js';
import VisitationForm from 'views/Form/Visitation/Auditor.js';
import AnswerActionEdit from 'views/AnswerAction/Edit.js';

// dinamically create dashboard routes
import auditorRoutes from "routes/auditor.js";

import image1 from "assets/img/full-screen-image-1.jpg";
import image2 from "assets/img/full-screen-image-2.jpg";
import image3 from "assets/img/full-screen-image-3.jpg";
import image4 from "assets/img/full-screen-image-4.jpg";

function AuditorLayout() {

  const { employeeId } = useParams();

  const [sidebarImage, setSidebarImage] = React.useState(image3);
  const [sidebarBackground, setSidebarBackground] = React.useState("purple");

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {

      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      return (
        <Route exact key={key}
          path={`${prop.layout}/:employeeId${prop.path}`}
          component={prop.component}
        />
      );
    });
  };

  return (
    <div className="wrapper">
      <Sidebar
        layout={`auditor`}
        routes={auditorRoutes}
        image={sidebarImage}
        background={sidebarBackground}
      />
      <div className="main-panel">
        <AdminNavbar />
        <div className="content">
          <Switch>
            <Route exact path="/auditor/:employeeId/proofs/:formId" component={ProofForm}/>
            <Route exact path="/auditor/:employeeId/evaluations/:formId" component={EvaluationForm}/>
            <Route exact path="/auditor/:employeeId/visitations/:formId" component={VisitationForm}/>
            <Route exact path="/auditor/:employeeId/actions/:actionId/edit" component={AnswerActionEdit}/>
            {getRoutes(auditorRoutes)}
            <Route path="/auditor/:employeeId/audits/:scheduleId" component={AuditShow}/>
          </Switch>
        </div>
        <AdminFooter />
        <div
          className="close-layer"
          onClick={() =>
            document.documentElement.classList.toggle("nav-open")
          }
        />
      </div>
    </div>
  );
}

export default AuditorLayout;
